import React from 'react';
import { BuyerAgreementContextProvider } from 'contexts';
import TourEditLayout from './TourEditLayout';
import { TourEditContextProvider } from './TourEditContext';
import { TourListingContextProvider } from './TourListingContext';
import { useFixMobile } from './hooks';

const TourEditPage: React.FC = () => {
  const ready = useFixMobile();
  return (
    ready && (
      <TourEditContextProvider>
        <TourListingContextProvider>
          <BuyerAgreementContextProvider>
            <TourEditLayout />
          </BuyerAgreementContextProvider>
        </TourListingContextProvider>
      </TourEditContextProvider>
    )
  );
};

export default TourEditPage;
